import { render, staticRenderFns } from "./kvTag.vue?vue&type=template&id=44b5f28e&scoped=true&"
import script from "./kvTag.vue?vue&type=script&lang=js&"
export * from "./kvTag.vue?vue&type=script&lang=js&"
import style0 from "./kvTag.vue?vue&type=style&index=0&id=44b5f28e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44b5f28e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/kivateknoloji/kivacloud/corona-ux/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('44b5f28e')) {
      api.createRecord('44b5f28e', component.options)
    } else {
      api.reload('44b5f28e', component.options)
    }
    module.hot.accept("./kvTag.vue?vue&type=template&id=44b5f28e&scoped=true&", function () {
      api.rerender('44b5f28e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/kiva/kvTag.vue"
export default component.exports